import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

import { environment } from 'src/environments/environment';

/**
 * Página pública apontada pelo QR Code impresso no rodapé da Certidão Digital.
 * Aceita a chave pela querystring (?chave=123456789012) ou digitada na tela.
 */
@Component({
    selector: 'app-validar-certidao',
    templateUrl: './validar-certidao.component.html',
    styleUrls: ['./validar-certidao.component.scss'],
})
export class ValidarCertidaoComponent implements OnInit {
    public chave = '';
    public isLoading = false;
    public certidao: any = null;
    public errorMessage = '';
    public hasSearched = false;

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        const chaveFromUrl = (this.route.snapshot.queryParamMap.get('chave') || '').trim();
        if (chaveFromUrl) {
            this.chave = chaveFromUrl;
            this.validar();
        }
    }

    get isChaveValida(): boolean {
        return /^\d{12}$/.test((this.chave || '').trim());
    }

    validar(): void {
        const chave = (this.chave || '').trim();

        this.hasSearched = true;
        this.certidao = null;
        this.errorMessage = '';

        if (!/^\d{12}$/.test(chave)) {
            this.errorMessage = 'A chave de autenticidade possui 12 dígitos numéricos.';
            return;
        }

        this.isLoading = true;
        this.http
            .get<{ ok: boolean; certidao?: any; message?: string }>(
                `${environment.apiURL}/api/free/certidao/validar/${chave}`,
            )
            .subscribe({
                next: (response) => {
                    this.isLoading = false;
                    if (response?.ok && response.certidao) {
                        this.certidao = response.certidao;
                    } else {
                        this.errorMessage = response?.message || 'Certidão não encontrada.';
                    }
                },
                error: (err) => {
                    this.isLoading = false;
                    this.errorMessage =
                        err?.error?.message || 'Não foi possível validar a certidão. Tente novamente mais tarde.';
                },
            });
    }
}
